(function () {
  'use strict';

  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.querySelector('[data-mobile-nav]');
      if (nav) nav.classList.toggle('is-open');
    });
  });

  document.querySelectorAll('[data-faq-q]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-faq-item]');
      if (!item) return;
      var wasOpen = item.classList.contains('is-open');
      document.querySelectorAll('[data-faq-item].is-open').forEach(function (el) {
        el.classList.remove('is-open');
        var s = el.querySelector('[data-faq-q] span');
        if (s) s.textContent = '+';
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        var span = btn.querySelector('span');
        if (span) span.textContent = '×';
      }
    });
  });

  var drawer = document.querySelector('[data-cart-drawer]');
  function openCart() {
    if (drawer) drawer.classList.add('is-open');
  }
  function closeCart() {
    if (drawer) drawer.classList.remove('is-open');
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });

  if (sessionStorage.getItem('oyroOpenCart') === '1') {
    sessionStorage.removeItem('oyroOpenCart');
    openCart();
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding…';
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          sessionStorage.setItem('oyroOpenCart', '1');
          window.location.reload();
        })
        .catch(function () {
          form.submit();
        });
    });
  });

  document.querySelectorAll('[data-qty]').forEach(function (row) {
    var key = row.getAttribute('data-line-key');
    var numEl = row.querySelector('.qty-num');
    row.querySelectorAll('[data-qty-delta]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (row.getAttribute('data-busy') === '1') return;
        btn.classList.add('is-flash');
        window.setTimeout(function () { btn.classList.remove('is-flash'); }, 220);
        var current = parseInt(numEl.textContent, 10) || 0;
        var next = current + parseInt(btn.getAttribute('data-qty-delta'), 10);
        if (next < 0) next = 0;
        numEl.textContent = String(next);
        row.setAttribute('data-busy', '1');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: next })
        }).then(function () {
          sessionStorage.setItem('oyroOpenCart', '1');
          window.location.reload();
        }).catch(function () {
          sessionStorage.setItem('oyroOpenCart', '1');
          window.location.reload();
        });
      });
    });
  });

  document.querySelectorAll('[data-empty-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (!window.confirm('Empty your cart?')) return;
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          btn.closest('form').submit();
        });
    });
  });

  var firstFaq = document.querySelector('[data-faq-item]');
  if (firstFaq) {
    firstFaq.classList.add('is-open');
    var s = firstFaq.querySelector('[data-faq-q] span');
    if (s) s.textContent = '×';
  }

  var liveEl = document.querySelector('[data-live-copy]');
  if (liveEl) {
    var lines = [
      '3-for-2 on every pack — buy 2, get 1 free',
      'Waking up dry? That is mouth breathing.',
      'Live offer on 10, 30 and 90 nights',
      'One strip tonight. Quieter morning tomorrow.',
      'Buy 2, get 1 free — every size, right now',
    ];
    var i = 0;
    setInterval(function () {
      i = (i + 1) % lines.length;
      liveEl.textContent = lines[i];
    }, 3800);
  }
})();